import { Component, inject } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Checkbox } from 'primeng/checkbox'
import { Fluid } from 'primeng/fluid'
import { InputText } from 'primeng/inputtext'
import { Panel } from 'primeng/panel'

import { LanguageService } from '@ti/core/ui-kit/i18n'
import { LangToggleComponent } from '@ti/core/ui-kit/layout/components/lang-toggle'
import { PasswordInputComponent } from '@ti/core/ui-kit/layout/components/password-input'
import { BaseSignInComponent, ForgotPasswordComponent } from '@ti/shared/auth-ui/components'
import { AuthenticatorCodeDialogComponent } from '@ti/shared/auth-ui/components/authenticator-code-dialog'
import { AuthenticatorSetupDialogComponent } from '@ti/shared/auth-ui/components/authenticator-setup-dialog'

import { McpAuthContext } from '../../../../mcp/bootstrap/mcp-auth-context'
import { isMcpContinuationReturnUrl } from '../../../../mcp/bootstrap/mcp-interaction-capture'

@Component({
  selector: 'app-sign-in-page',
  templateUrl: 'sign-in-page.component.html',
  styleUrl: 'sign-in-page.component.scss',
  imports: [
    Panel,
    PrimeTemplate,
    ReactiveFormsModule,
    Fluid,
    InputText,
    PasswordInputComponent,
    TranslatePipe,
    ForgotPasswordComponent,
    Button,
    Checkbox,
    LangToggleComponent,
    AuthenticatorCodeDialogComponent,
    AuthenticatorSetupDialogComponent,
  ],
})
export class TspAdminSignInPageComponent extends BaseSignInComponent {
  protected readonly isBannerEnabled = true
  protected override languageService = inject(LanguageService)
  private readonly mcpContext = inject(McpAuthContext)

  // Signing in to continue an MCP authorization is not a visit of the application: the ordinary
  // is-active read and the login audit write stay out of it. The server decides on the session.
  // Only an attempt this tab holds counts, so a hand-made return link keeps the ordinary audit.
  protected override checkIsUserActive() {
    return this.isMcpContinuation() ? Promise.resolve(true) : super.checkIsUserActive()
  }

  protected override trackLogin() {
    if (!this.isMcpContinuation()) super.trackLogin()
  }

  private isMcpContinuation() {
    return this.mcpContext.isAuthFlow && isMcpContinuationReturnUrl(this.returnUrl)
  }

  get bannerUrl() {
    if (this.isBannerEnabled) {
      switch (this.languageService.current()) {
        case 'en': {
          return 'url(./assets/images/banner-large-VelocityIoT-en.png)'
        }
        case 'es': {
          return 'url(./assets/images/banner-large-M2M-updated-es.webp)'
        }
      }
    }
    return 'url(./assets/images/banner-placeholder.webp)'
  }

  public openBannerLink() {
    if (this.isBannerEnabled) {
      switch (this.languageService.current()) {
        case 'en': {
          return window.open('https://velocityiot.io/free-trial-telematic-insights/', '_blank')
        }
        case 'es': {
          return window.open(
            'https://m2mdataglobal.com/conectividad-m2m-global/?utm_source=telematicsinsights&utm_medium=cpc&utm_campaign=telematics_insights_conectividad/',
            '_blank',
          )
        }
      }
    }
  }
}
